var _defs, _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _polyline, _polygon, _polygon2, _path3, _polyline2, _polyline3, _polygon3, _polygon4, _path4, _polyline4, _path5, _polygon5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBot03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 185 208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e425e6;}.cls-2{fill:#fff;}.cls-3{fill:#e30407;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40.5,
    y: 15,
    width: 104,
    height: 59
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M181.5,51a24,24,0,0,0-24-24V75A24,24,0,0,0,181.5,51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.5,51a24,24,0,0,0,24,24V27A24,24,0,0,0,3.5,51Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 55.5,
    y: 172,
    width: 28,
    height: 17
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 50.5,
    y: 194,
    width: 35,
    height: 14
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 101.5,
    y: 172,
    width: 28,
    height: 17
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 99.5,
    y: 194,
    width: 35,
    height: 14
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "24.5 112 16.5 115 26.5 130 30.5 126 24.5 112"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.5 120 8.5 130 20.5 137 22.5 133 13.5 120"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.5 134 5.5 145 18.5 144 18.5 141 6.5 134"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.5,166.5a6.5,6.5,0,0,1,13-.66l8.83,5.36a16.2,16.2,0,0,0,.7-4.7A16,16,0,1,0,5.29,178.36l4.83-9.11A6.45,6.45,0,0,1,9.5,166.5Z"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "5.5 148 17.5 147 17.5 151 4.5 156"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "160.5 112 168.5 115 158.5 130 154.5 126 160.5 112"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "171.5 120 176.5 130 164.5 137 162.5 133 171.5 120"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "178.5 134 179.5 145 166.5 144 166.5 141 178.5 134"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M175.5,166.5a6.5,6.5,0,0,0-13-.66l-8.83,5.36a16.2,16.2,0,0,1-.7-4.7,16,16,0,1,1,26.71,11.86l-4.83-9.11A6.45,6.45,0,0,0,175.5,166.5Z"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "179.5 148 167.5 147 167.5 151 180.5 156"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.5,0V105h120V0Zm29,68a15,15,0,1,1,15-15A15,15,0,0,1,61.5,68Zm62,0a15,15,0,1,1,15-15A15,15,0,0,1,123.5,68Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "32.46 110 49.41 165 135.59 165 152.54 110 32.46 110"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63,132.05H59.31v-1h8.54v1H64.16v10.16H63Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.62,131v11.17H69.48V131Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.42,137.24c0-2.13,0-4.23.06-5.38h0c-.46,1.64-2.52,6.83-3.88,10.35H78.49c-1-2.79-3.16-8.58-3.67-10.37h0c.09,1.29.12,3.84.12,5.75v4.62H73.8V131h1.71c1.41,3.67,3.17,8.43,3.57,9.77h0c.26-.93,2.31-6.21,3.76-9.77h1.67v11.17H83.42Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.47,136.84H88.83v4.36H95l-.16,1H87.7V131h7v1H88.83v3.78h5.64Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.33,131v6.75c0,2.82,1.57,3.56,3.08,3.56,1.78,0,3.08-.78,3.08-3.56V131h1.15v6.69c0,3.55-1.92,4.62-4.26,4.62s-4.22-1.17-4.22-4.5V131Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.66,131h4.11c2.1,0,3.54,1.17,3.54,3.17s-1.47,3.26-3.65,3.26h-2.84v4.74h-1.16Zm1.16,5.43h2.85c1.69,0,2.44-.86,2.44-2.22a2.11,2.11,0,0,0-2.37-2.21h-2.92Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123.43,138.55l-.12-5.54v-2h1.16v2l-.11,5.54Zm-.09,3.68v-2h1.07v2Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot03);
export default __webpack_public_path__ + "static/media/bot-03.f1e4c4297f24bf0d76bf15f68799a73e.svg";
export { ForwardRef as ReactComponent };